module.exports = __webpack_public_path__ + "img/File.cfbdc813.png";